import { useLocation } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import FormGenerator from "../../plugins/formGenerator/form";
import { TopMenu } from "../../plugins/dataTable/json/TopMenu";
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";

export function Employee() {
  const navigate = useNavigate();

  const handleRoute = (path: any) => {
    if (path === "form") {
      navigate(path);
    } else {
      alert(path + " button currently not working");
    }
  };

  const getTopmenu = TopMenu.filter((item: any) => item?.formId === "Employee");
  return (
    <>
      <PageMeta title="TTM Add Carriers | Admin Carriers" description="" />
      {/* <PageBreadcrumb pageTitle="Carrier" /> */}
      <div>
        <div className="">
          <div className="flex items-end text-right justify-end gap-2 mb-2">
            {getTopmenu[0]?.menus?.map((getItem: any, index: number) => (
              <div key={index}>
                <Button
                  size="small"
                  sx={{
                    boxShadow: "0",
                  }}
                  color={getItem?.color}
                  variant={getItem?.verient}
                  startIcon={<i className={getItem?.icon}></i>}
                  onClick={() => handleRoute(getItem?.to)}
                >
                  {getItem?.label}
                </Button>
              </div>
            ))}
          </div>
        </div>
        <FormGenerator
          formId="Employee"
          formIntData={{
            topMenus: false,
            tabs: true,
          }}
        />
      </div>
    </>
  );
}
